const navLinks = [
  'Features', 'Pricing', 'Resources'
];

export {navLinks};